import { IOperatorModel } from './operator.model';
import { IParkingCategoryModel } from './parking-category.model';
import { IParkingTypeModel } from './parking-type.model';

export interface IParkingModel {
  id: string;
  name: string;
  type: IParkingTypeModel;
  address: string;
  location: IParkingLocationModel;
  category: IParkingCategoryModel;
  isBlocked: boolean;
  operator: IOperatorModel;
  floor: number;
  workingHours: null;
  capacity: number;
  status: ParkingStatuses;
  isPaid: boolean;
  isPrivate: boolean;
  createdAt: string;
  tariffs: number[];
  eventType?: string;
}

export interface IParkingLocationModel {
  x?: number;
  y?: number;
}

export enum ParkingStatuses {
  Active,
  Inactive,
  Repair,
}
